export const areaCalculation = (area: number) =>
  area > 1 ? `${area} هکتار` : ` ${area * 10000} مترمربع `;
